module.exports = __webpack_public_path__ + "media/components/breakheader/static/surf-alert-83d1839c01983cee79632089f77cbb3e.png";